import React from 'react';
import AuthPage from './AuthPage';

export default function SignupPage() {
  return <AuthPage initialScreen="register" />;
}
